import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from "@angular/core";
import { MenuPackage } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/rightclick/context-menu-injector";
import { ContextMenuService } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/rightclick/context-menu.service";
import { MenuComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/rightclick/menu.component";
import { AccountService, AuthService, HttpCommonService } from "projects/sepidz-web-framework/src/lib/services";
import { ContextMenuEnum } from "../../../model/contextMenuenum";
import { take } from "rxjs/operators";
import { CategoryPopupState, StockInWebKind } from "src/app/frontoffice/catalog/model/item.model";

@Component({
  selector: "simple-menu",
  // add your menu html
  template: `
    <ng-container *ngIf="isCategory; else isItems">
      <a
        *ngIf="
          !menuPackage.context.visible &&
          showStockInWeb &&
          !showStockInWebDeposit &&
          !menuPackage.context.value.notAvailableGoodIds?.length &&
          menuPackage.context.value.categoryPopupState == categoryPopupState.AllNonAvailable
        "
        class="simple-menu-box"
        (click)="handleClick(StockInWebKindEnum.Available)">
        {{ "ClientApp.FrontOffice.Order.OrderPage.Item.Desktop.MakeAvailable" | translate }}
      </a>
      <a
        *ngIf="
          (menuPackage.context.value.categoryPopupState !== categoryPopupState.AllNonAvailable || !menuPackage.context.value.StockInWeb) &&
          !menuPackage.context.visible &&
          showStockInWeb
        "
        class="simple-menu-box"
        (click)="handleClick(StockInWebKindEnum.UnAvailable)">
        {{ "ClientApp.FrontOffice.Order.OrderPage.Item.Desktop.MakeUnavailable" | translate }}
      </a>
      <a
        *ngIf="
          (menuPackage.context.value.categoryPopupState !== categoryPopupState.AllNonAvailable || menuPackage.context.value.StockInWeb !== 1) &&
          !menuPackage.context.visible &&
          showStockInWeb
        "
        class="simple-menu-box"
        (click)="handleClick(StockInWebKindEnum.UnAvailableOnSite)">
        {{ "ClientApp.FrontOffice.Order.OrderPage.Item.Desktop.UnavailableOnSite" | translate }}
      </a>
    </ng-container>
    <ng-template #isItems>
      <a
        *ngIf="
          menuPackage.context.value.StockInWeb &&
          !menuPackage.context.visible &&
          showStockInWeb &&
          !menuPackage.context.value.notAvailableGoodIds?.length
        "
        class="simple-menu-box"
        (click)="handleClick(StockInWebKindEnum.Available)">
        {{ "ClientApp.FrontOffice.Order.OrderPage.Item.Desktop.MakeAvailable" | translate }}
      </a>
      <a
        *ngIf="!menuPackage.context.value.StockInWeb && !menuPackage.context.visible && showStockInWeb"
        class="simple-menu-box"
        (click)="handleClick(StockInWebKindEnum.UnAvailable)">
        {{ "ClientApp.FrontOffice.Order.OrderPage.Item.Desktop.MakeUnavailable" | translate }}
      </a>
      <a
        *ngIf="!menuPackage.context.value.StockInWeb && !menuPackage.context.visible && showStockInWeb"
        class="simple-menu-box"
        (click)="handleClick(StockInWebKindEnum.UnAvailableOnSite)">
        {{ "ClientApp.FrontOffice.Order.OrderPage.Item.Desktop.UnavailableOnSite" | translate }}
      </a>
      <ng-template #isItems
        >'
        <a
          *ngIf="
            menuPackage.context.value.StockInWeb &&
            !menuPackage.context.visible &&
            showStockInWeb &&
            !showStockInWebDeposit &&
            !menuPackage.context.value.notAvailableGoodIds?.length
          "
          class="simple-menu-box"
          (click)="handleClick(StockInWebKindEnum.Available)">
          {{ "ClientApp.FrontOffice.Order.OrderPage.Item.Desktop.MakeAvailable" | translate }}
        </a>
        <a
          *ngIf="!menuPackage.context.value.StockInWeb && !menuPackage.context.visible && showStockInWeb && !showStockInWebDeposit"
          class="simple-menu-box"
          (click)="handleClick(StockInWebKindEnum.UnAvailable)">
          {{ "ClientApp.FrontOffice.Order.OrderPage.Item.Desktop.MakeUnavailable" | translate }}
        </a>
        <a
          *ngIf="!menuPackage.context.value.StockInWeb && !menuPackage.context.visible && showStockInWeb && !showStockInWebDeposit"
          class="simple-menu-box"
          (click)="handleClick(StockInWebKindEnum.UnAvailableOnSite)">
          {{ "ClientApp.FrontOffice.Order.OrderPage.Item.Desktop.UnavailableOnSite" | translate }}
        </a>
      </ng-template>
    </ng-template>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SimpleMenuComponent extends MenuComponent implements OnInit {
  // this module does not have animations, set lazy false
  lazy = false;
  StockInWebKindEnum = StockInWebKind;
  isCategory: boolean = true;
  showStockInWeb: boolean = false;
  @Output() hasActiveItem = new EventEmitter<any>();
  showStockInWebDeposit: boolean;
  availableCount: number = 0;
  unAvailableCount: number = 0;
  unAvailableInSiteCount: number = 0;
  categoryPopupState = CategoryPopupState;
  constructor(
    public menuPackage: MenuPackage,
    public contextMenuService: ContextMenuService,
    public http: HttpCommonService,
    private accountService: AccountService,
    public authService: AuthService
  ) {
    super(menuPackage, contextMenuService);
    // grab any required menu context passed via menuContext input
  }
  ngOnInit(): void {
    if (this.menuPackage?.context?.enum === ContextMenuEnum.Category) this.isCategory = true;
    else this.isCategory = false;
    this.hasPermissionChangeStockInWeb();
  }
  handleClick(StockInWeb?: StockInWebKind) {
    // IMPORTANT! tell the menu to close, anything passed in here is given to (menuAction)
    switch (this.menuPackage.context.enum) {
      case ContextMenuEnum.Category:
        this.menuPackage.context.order?.splashFormService?.openDialog("");
        this.http
          .get(
            `ItemCategory/StockInWebItemsByCategory/${this.menuPackage.context.value.Id}/${StockInWeb}/${this.accountService.authService.currentBranchId}`
          )
          .pipe(take(1))
          .subscribe(
            (data) => {
              this.menuPackage.context.order.itemHasParent = null;
              this.menuPackage.context.order?.detectChanges();
              this.menuPackage.context.value.categoryPopupState == StockInWeb;
              this.menuPackage.context.order?.splashFormService?.closeLoading();
            },
            (err) => {
              this.menuPackage.context.order?.splashFormService?.closeLoading();
            }
          );

        break;
      case ContextMenuEnum.Item:
        this.menuPackage.context.order?.splashFormService?.openDialog("");
        this.http
          .get(`Item/StockInWeb/${this.menuPackage.context.value.Id}/${StockInWeb}`)
          .pipe(take(1))
          .subscribe(
            (data) => {
              this.menuPackage.context.value.StockInWeb = data;
              this.menuPackage.context.order.itemHasParent = null;
              this.menuPackage.context.order?.detectChanges();
              this.menuPackage.context.order?.splashFormService?.closeLoading();
            },
            (err) => {
              this.menuPackage.context.order?.splashFormService?.closeLoading();
            }
          );

        break;
      default:
        break;
    }

    this.contextMenuService.closeAll();
  }
  hasPermissionChangeStockInWeb() {
    if (this.menuPackage.context.order.HasAccess("StockInWeb")) {
      this.showStockInWeb = true;
    }
  }
  hasStockInWebIndeposit() {
    if (this.menuPackage.context.order.saleMethodBranch.HasDeposit) {
      this.showStockInWebDeposit = true;
    }
  }
}
